import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { translate } from 'react-i18next';
import Flight from '../../Store/Flight';
import { Alert, Row, Col, Button } from 'reactstrap';
import LanguageStore from '../../../lang';
import FlightCard from './FlightCard';
import FlightTable from './FlightTable';
import DisplayToggle from '../../Components/DisplayToggle';

const FontAwesome = require('react-fontawesome');

const FlightEntry = ({ flight, onClick }) => (
  <Col xs='12' md='6' lg='4'>
    <div className='pt-4'>
      <FlightCard flight={flight} onClick={onClick} />
    </div>
  </Col>
);

@observer
export class FlightSection extends Component {
  state = {
    response: { first: true, last: true },
    flights: [],
    loading: true,
    firstLoad: true,
    page: 1,
    tableView: false,
  };

  componentDidMount() {
    this.load();
  }

  componentWillReceiveProps(newProps) {
    if (newProps.locations !== this.props.locations) {
      this.setState({ flights: [] });
      this.load(this.state.page, newProps.locations);
    }
  }

  async load(page = 1, locations) {
    this.setState({ loading: true });
    const response = await Flight.findNext(page, LanguageStore.lang, locations || this.props.locations);
    const flights = this.state.flights.concat(response.content);
    this.setState({ page, response, loading: false, firstLoad: false, flights });
  }

  handleClick = (flightOffer) => {
  };

  handleLoadMore = () => {
    this.load(this.state.page + 1);
  };

  toggleView = () => {
    this.setState((prevState) => ({ tableView: !prevState.tableView }));
  };

  render() {
    const { t } = this.props;
    const { loading, firstLoad, response, flights, tableView } = this.state;
    const iconName = !tableView ? 'list' : 'th';
    const iconTitle = tableView ? t('Card View') : t('Table View');

    return (
      <Row>
        <Col>
          <Row>
            <Col className='d-flex justify-content-between align-items-center'>
              <h1>{t('Flüge demnächst')}</h1>
            </Col>
          </Row>
          <Row>
            <Col xs='12' className='mb-4 text-center text-lg-left'>
              <Button color='secondary' onClick={this.toggleView}><FontAwesome name={iconName} /> {iconTitle}</Button>
            </Col>
          </Row>
          <DisplayToggle show={!loading || !firstLoad}>
            {tableView ? (
              <Row>
                <Col className='overflow-auto'>
                  <FlightTable flights={flights} t={t} />
                </Col>
              </Row>
            ) : (
              <Row>
                {flights.map((f, i) => (
                  <Col key={i} xs='12' md='6' lg='4' className='mb-4'>
                    <FlightCard flight={f} onClick={this.handleClick} />
                  </Col>
                ))}
              </Row>
            )}
          </DisplayToggle>
          <DisplayToggle show={loading && firstLoad}>
            <Row>
              <Col>
                <Alert color='info'>{t('Unsere Flüge werden gerade geladen')}</Alert>
              </Col>
            </Row>
          </DisplayToggle>
          <DisplayToggle show={!firstLoad && !response.last && flights.length > 0}>
            <Row>
              <Col className='d-flex justify-content-center'>
                <div className='pt-5 pb-5'>
                  <Button color='secondary' size='lg' onClick={this.handleLoadMore} block disabled={loading}>
                    {t('Weitere Flüge laden')}
                  </Button>
                </div>
              </Col>
            </Row>
          </DisplayToggle>
          <DisplayToggle show={!loading && !flights.length}>
            <Row>
              <Col>
                <Alert color='warning'>{t('Zurzeit stehen keine Flüge an')}</Alert>
              </Col>
            </Row>
          </DisplayToggle>
        </Col>
      </Row>
    );
  }
}

export default translate()(FlightSection);



// WEBPACK FOOTER //
// ./src/App/Dashboard/Flight/index.js